import ContextMenu from "../context-menu/ContextMenu";
import { ActionItem } from "../context-menu/PopoverList";
import { FC, useCallback, useState } from "react";
import Permission from "../../auth/Permission";

import "./GenericTableSelect.scss"

type Props = {
  headers: Record<string, string>;
  data: Record<string, unknown>[];
  actions?: ActionItem[];
  renders?: Record<string, (data: unknown, context: unknown) => JSX.Element | FC | string | number>;
  subtitles?: Record<string, string>;
  entity?: string;
  rowClassName?: (data: Record<string, unknown>) => string;
  setFilters?: (filters: { orderBy: string }) => void;
  onClick: (data) => void
  load: boolean
};

function GenericTableSelect(props: Props) {
  const [sortConfig, setSortConfig] = useState<{ key: string | null, direction: 'asc' | 'desc' }>({ key: null, direction: 'asc' });

  const renterItem = useCallback((key, value, data) => {
    return (props.renders && props.renders[key])
      ? props.renders[key](value, data)
      : value;
  }, [props]);

  const handleSort = (key: string) => {
    const direction = (sortConfig.key === key && sortConfig.direction === 'asc') ? 'desc' : 'asc';
    setSortConfig({ key, direction });
    if (props.setFilters) {
      props.setFilters({ orderBy: direction === 'asc' ? key : `-${key}` });
    }
  };

  return (
    <div className="generic-table generic-table-select">

      <table className="generic-table-style">
        <thead className="generic-table-thead">
          <tr>
            {Object.entries(props.headers).map(([key, title], index) => (
              <th key={key + index} className="generic-table-header">
                <div className="flex justify-center align-middle">
                  <div className="generic-table-header-title" onClick={() => handleSort(key)}>
                    {title}
                    {props.subtitles && props.subtitles[key] && <div className="text-xs">{props.subtitles[key]}</div>}
                  </div>
                  <div className="generic-table-header-title" onClick={() => handleSort(key)}>
                    {sortConfig.key === key ? (sortConfig.direction === 'asc' ? ' ↑' : ' ↓') : ''}
                  </div>
                </div>
              </th>
            ))}
            <Permission permission="view" entity={props.entity}>
              <td className="generic-table-th">
                {props.actions && <th className="generic-table-th">Ações</th>}
              </td>
            </Permission>
          </tr>
        </thead>
        <tbody className="bg-white">
          {(props.data.length && !props.load) == 0 && (
            <tr className={'bg-white grid-cols-2'}>
              <td className="py-3 text-center" colSpan={Object.keys(props.headers).length + (props.actions ? 1 : 0)}>
              </td>
            </tr>
          )}
          {props.load &&
            <div className="dots-loader">
              <p className="carregando">CARREGANDO NFEs</p>
              <span></span>
              <span></span>
              <span></span>
            </div>

          }
          {props.data[0] && (
            props.data.map((item, index) => (
              <tr
                key={Date.now().toString() + index}
                className={`${index % 2 ? 'bg-gray2/10' : 'bg-white'} ${props.rowClassName ? props.rowClassName(item) : ''}`}
                onClick={() => props.onClick(item)}
              >
                {Object.keys(props.headers).map((key, index) => (
                  <td key={key + index + Date.now().toString()} className="generic-table-th text-black dark:text-black">
                    {renterItem(key, item[key], item)}
                  </td>
                ))}
                <Permission permission="view" entity={props.entity}>
                  <td className="generic-table-th">
                    {props.actions && <ContextMenu data={item} actions={props.actions} />}
                  </td>
                </Permission>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}

export default GenericTableSelect;

